import { _Web } from "../webs/types.js";
import { AppCatalog } from "./types.js";
_Web.prototype.getAppCatalog = function (url, scope) {
    if (scope === void 0) { scope = "tenant"; }
    return AppCatalog(url || this, "_api/web/" + scope + "appcatalog/AvailableApps").configureFrom(this);
};
//# sourceMappingURL=web.js.map